import { MaskingRule } from './rudder-stack.types';

export const maskingRules: MaskingRule[] = [
  { pattern: /^\/login\/[^/]+/, replacement: '/login/*' },
  { pattern: /^\/s\/[^/]+/, replacement: '/s/*' },
];
